import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Modal } from 'primsell-shared-layer/components'

import { currentStepSelector, RedeemActions } from 'features'
import { BurnDialogContent, ProgressBar } from './components'

import { REDEEM_PROGRESS_STEPS } from './redeem-progress-modal.config'

const RedeemProgressModal = () => {
  const dispatch = useDispatch()

  const currentStep = useSelector(currentStepSelector)

  const onClose = useCallback(() => {
    dispatch(RedeemActions.resetRedeemProgress())
  }, [dispatch])

  return (
    <Modal onClose={onClose}>
      <Modal.Content>
        <div style={{ paddingBottom: '32px' }}>
          {REDEEM_PROGRESS_STEPS[currentStep].component}
          <BurnDialogContent />
          <ProgressBar />
        </div>
      </Modal.Content>
    </Modal>
  )
}

export { RedeemProgressModal }
